import React from 'react';

interface UserAvatarProps {
  iconUrl?: string | null;
  username?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  iconUrl,
  username = 'User',
  size = 'md',
  className = ''
}) => {
  // Size mappings
  const sizeClasses = {
    sm: 'h-6 w-6 text-sm',
    md: 'h-8 w-8 text-base',
    lg: 'h-12 w-12 text-xl',
    xl: 'h-16 w-16 text-2xl'
  };

  const getInitials = (name: string) => {
    const initials = name.trim().split(' ').filter(Boolean).map(n => n[0]).join('').substring(0, 2).toUpperCase();
    return initials || 'U';
  };

  if (iconUrl) {
    // If icon URL is an emoji (single character or emoji sequence), display it
    if (iconUrl.length <= 4) {
      return (
        <div className={`${sizeClasses[size]} rounded-full flex items-center justify-center ${className}`}>
          <span className={`${size === 'sm' ? 'text-base' : size === 'md' ? 'text-xl' : size === 'lg' ? 'text-2xl' : 'text-3xl'}`}>
            {iconUrl}
          </span>
        </div>
      );
    }

    // Otherwise, treat it as an image URL
    return (
      <div className={`${sizeClasses[size]} rounded-full flex items-center justify-center ${className}`}>
        <img
          src={iconUrl}
          alt={username}
          className="h-full w-full rounded-full object-cover"
        />
      </div>
    );
  }

  // Fallback to initials
  const initials = getInitials(username);

  return (
    <div className={`${sizeClasses[size]} bg-mango-500 rounded-full flex items-center justify-center ${className}`}>
      <span className="text-sm font-medium text-white">{initials}</span>
    </div>
  );
};

export default UserAvatar;
